import { faClose, faQuestion } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FeatureTooltip } from '@karnov/kui-react'
import { useCallback } from 'react'

import { DropdownMenuTrigger } from 'components/DropdownMenu'
import { useTriggerEvent } from 'hooks/useTriggerEvent'
import { useTranslation } from 'services/i18n'
import { useIsPanelOpen } from 'stores/usePanelsStateStore'
import { cn } from 'utils/cn'

import type { FC } from 'react'

type Props = {
  isHelpAndFeedbackMenuOpen: boolean
  onToggleHelpAndFeedbackMenu: VoidFunction
}

export const HelpAndFeedbackMenuButton: FC<Props> = ({
  isHelpAndFeedbackMenuOpen,
  onToggleHelpAndFeedbackMenu,
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'help_and_feedback',
  })

  const triggerEvent = useTriggerEvent()

  const isReferencesPanelOpen = useIsPanelOpen('references')

  const handleOpenDropdown = useCallback(() => {
    onToggleHelpAndFeedbackMenu()

    triggerEvent({
      name: 'kai_help_menu_opened',
    })
  }, [onToggleHelpAndFeedbackMenu, triggerEvent])

  return (
    <DropdownMenuTrigger asChild>
      <div className={cn('fixed bottom-4 right-4 z-10 print:hidden', {
        'right-9 bottom-8 xl:right-11': isReferencesPanelOpen,
        'bottom-4 right-4': !isReferencesPanelOpen,
      })}
      >

        <FeatureTooltip content={t('button')}>
          <button
            aria-label={t('button')}
            className="flex size-8 items-center justify-center rounded-full border border-default bg-action-default focus:shadow-accessibility focus:outline-none lg:shadow"
            onClick={handleOpenDropdown}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault()
                handleOpenDropdown()
              }
            }}
            onKeyUp={(e) => {
              if (e.key === ' ') {
                e.preventDefault()
                handleOpenDropdown()
              }
            }}
            type="button"
          >
            <FontAwesomeIcon
              icon={isHelpAndFeedbackMenuOpen ? faClose : faQuestion}
            />
          </button>
        </FeatureTooltip>
      </div>
    </DropdownMenuTrigger>
  )
}
